import React from 'react';
import Location from './Location'


export default function Orders({clicked}){
    return(
        <div className="Orders__Items">
            <Location clicked={clicked} />
        </div>
    )
}